import actions from './actions'
import mutations from './mutations'

const state = {
  id: null,
  name: null,
  email: null
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js